import React from 'react';
import moment from 'moment';
import { ISODate } from '../../../../commonv3/types/dates';

type Props = {
  date: ISODate;
};
export const SlashFormattedDate = ({ date }: Props) => <span>{moment(date).format('YYYY/MM/DD')}</span>;
